// Display-level clan-name cleanup. Many imported/legacy clan ids carry
// underscores where spaces belong (NK_ZA_EAGLES, AKA_ACADEMY). Render them
// with spaces — NEVER mutate the underlying name/id, which keys links,
// applications, and DDB partitions. (A proper per-clan displayName field
// can supersede this later.)

// Brand spellings no transform can guess (Lisa, 2026-06-12). Keyed on the
// RAW stored name; the value is rendered verbatim (CSS may still uppercase).
const EXACT_BRANDS: Record<string, string> = {
  KARE: '$KARE',
};

export function displayClanName(name: string): string {
  if (EXACT_BRANDS[name]) return EXACT_BRANDS[name];
  return name
    // M.o.M family: M_O_M_ECLIPSE → M.o.M ECLIPSE
    .replace(/^M_O_M(_|$)/, 'M.o.M ')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

// THE way to label a clan from a (denormalized displayName stamp, canonical
// id) pair. Backend endpoints increasingly stamp a verbatim displayName
// (e.g. clan1DisplayName) alongside the canonical CLAN#XXX id — when present,
// render it verbatim (it preserves the clan's real casing/punctuation, like
// "$kare"). When absent (older rows, or ids not yet backfilled), fall back to
// formatting the canonical id through displayClanName. New match/roster UI
// should call this instead of hand-rolling `x.clan1DisplayName ?? stripClanPrefix(x.clan1)`.
export function clanLabelFrom(displayName: string | null | undefined, rawId: string | null | undefined): string {
  if (displayName) return displayName;
  return displayClanName((rawId || '').replace(/^CLAN#/, ''));
}
